import { render, staticRenderFns } from "./TodaysReturnStatus.vue?vue&type=template&id=9585e36a&scoped=true&"
import script from "./TodaysReturnStatus.vue?vue&type=script&lang=js&"
export * from "./TodaysReturnStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9585e36a",
  null
  
)

export default component.exports